import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { publicAPI } from '../../lib/api';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';

export default function ContactPage() {
  const [content, setContent] = useState({});

  useEffect(() => {
    publicAPI.getContent('contact').then(r => setContent(r.data));
  }, []);

  return (
    <>
      <Helmet>
        <title>Iletisim | Endustriyel Hizmetler</title>
        <meta name="description" content="Endustriyel uretim hizmetleri icin bizimle iletisime gecin." />
      </Helmet>

      <section className="bg-slate-50 py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-semibold mb-2" data-testid="contact-title">Iletisim</h1>
          <p className="text-muted-foreground">Sorulariniz icin bize ulasin.</p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 gap-6">
            <Card>
              <CardContent className="p-6 flex items-start gap-4">
                <Phone className="h-6 w-6 text-[hsl(221,83%,22%)] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Telefon</h3>
                  <p className="text-sm text-muted-foreground">{content.phone || '+90 212 000 00 00'}</p>
                </div>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="p-6 flex items-start gap-4">
                <Mail className="h-6 w-6 text-[hsl(221,83%,22%)] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">E-posta</h3>
                  <p className="text-sm text-muted-foreground">{content.email || 'info@industrialhub.com'}</p>
                </div>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="p-6 flex items-start gap-4">
                <MapPin className="h-6 w-6 text-[hsl(221,83%,22%)] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Adres</h3>
                  <p className="text-sm text-muted-foreground">{content.address || 'Istanbul, Turkiye'}</p>
                </div>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="p-6 flex items-start gap-4">
                <Clock className="h-6 w-6 text-[hsl(221,83%,22%)] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Calisma Saatleri</h3>
                  <p className="text-sm text-muted-foreground">Pazartesi - Cuma: 09:00 - 18:00</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </>
  );
}
